module.exports = __webpack_public_path__ + "img/hlm-zentrale.fbb81c2a.jpg";